<div class="row-detail">
  @switch (row.decision_kind) {
    @case ('pick_existing') {
      @if (row.candidates.length) {
        <p class="row-detail__lead">
          {{ 'TRANS__IMPORT__VALUE_REVIEW__PICK_LEAD' | translate: {count: row.candidates.length, value: row.source_value} }}
        </p>
        <mat-radio-group
          class="row-detail__candidates"
          [value]="pickedId"
          (change)="pick($event.value)"
          [attr.aria-label]="'TRANS__IMPORT__VALUE_REVIEW__PICK_LEAD' | translate: {count: row.candidates.length, value: row.source_value}"
        >
          <div class="row-detail__candidate row-detail__candidate--head" aria-hidden="true">
            <span>{{ 'TRANS__IMPORT__VALUE_REVIEW__COL_NAME' | translate }}</span>
            <span>{{ 'TRANS__IMPORT__VALUE_REVIEW__COL_PLACEMENT' | translate }}</span>
            <span>{{ 'TRANS__IMPORT__VALUE_REVIEW__COL_CODE' | translate }}</span>
            <span>KulturNav</span>
            <span>{{ 'TRANS__IMPORT__VALUE_REVIEW__COL_USAGE' | translate }}</span>
            <span>{{ 'TRANS__IMPORT__VALUE_REVIEW__COL_ID' | translate }}</span>
            <span></span>
          </div>
          @for (c of row.candidates; track c.candidate_artifact_id) {
            <div class="row-detail__candidate" [class.row-detail__candidate--selected]="c.is_selected">
              <mat-radio-button [value]="c.candidate_artifact_id">
                <span class="row-detail__name" [class.row-detail__struck]="c.candidate_valid === false">
                  {{ c.candidate_name }}
                </span>
              </mat-radio-button>
              <span class="row-detail__placement">
                @if (c.candidate_path) {
                  {{ 'TRANS__IMPORT__VALUE_REVIEW__UNDER' | translate: {path: c.candidate_path} }}
                } @else {
                  {{ 'TRANS__IMPORT__VALUE_REVIEW__TOP_LEVEL' | translate }}
                }
                @if (c === mostUsed) {
                  <span class="row-detail__tag">{{ 'TRANS__IMPORT__VALUE_REVIEW__MOST_USED' | translate }}</span>
                }
                @if (c.candidate_is_suggestion) {
                  <span class="row-detail__tag">{{ 'TRANS__IMPORT__VALUE_REVIEW__SUGGESTION' | translate }}</span>
                }
                @if (c.candidate_valid === false) {
                  <span class="row-detail__tag row-detail__tag--warn">{{ 'TRANS__IMPORT__VALUE_REVIEW__STRUCK' | translate }}</span>
                }
              </span>
              <span>{{ c.candidate_code || '–' }}</span>
              <span>
                @if (c.candidate_has_authority) {
                  <span class="row-detail__authority">KulturNav</span>
                } @else {
                  –
                }
              </span>
              <span class="row-detail__number">
                @if (c.candidate_usage_count == null) {
                  –
                } @else {
                  {{ 'TRANS__IMPORT__VALUE_REVIEW__USAGE' | translate: {count: c.candidate_usage_count} }}
                }
              </span>
              <span class="row-detail__id">{{ shortId(c) }}</span>
              <a
                mat-icon-button
                class="row-detail__open"
                target="_blank"
                rel="noopener noreferrer"
                [href]="termUrl(c)"
                [attr.aria-label]="'TRANS__IMPORT__VALUE_REVIEW__OPEN_TERM' | translate: {name: c.candidate_name}"
              >
                <mat-icon>open_in_new</mat-icon>
              </a>
            </div>
          }
        </mat-radio-group>
      } @else {
        <p class="row-detail__lead">
          {{ 'TRANS__IMPORT__VALUE_REVIEW__PICK_NO_CANDIDATES' | translate: {value: row.source_value} }}
        </p>
      }
      <app-concept-term-search
        class="row-detail__search"
        [fieldId]="field.target_field"
        [objectType]="objectType"
        (termPicked)="onTermPicked($event)"
      ></app-concept-term-search>
    }

    @case ('create_new') {
      <p class="row-detail__lead">
        {{ 'TRANS__IMPORT__VALUE_REVIEW__CREATE_LEAD' | translate: {field: fieldLabel} }}
      </p>
      <div class="row-detail__create">
        <mat-form-field appearance="outline" subscriptSizing="dynamic" class="row-detail__create-name">
          <mat-label>{{ 'TRANS__IMPORT__CONCEPT_NEW_NAME' | translate }}</mat-label>
          <input matInput [(ngModel)]="row.new_concept_name" (ngModelChange)="onNewTermEdited()">
        </mat-form-field>
        <mat-form-field appearance="outline" subscriptSizing="dynamic" class="row-detail__create-code">
          <mat-label>{{ 'TRANS__IMPORT__CONCEPT_NEW_CODE' | translate }}</mat-label>
          <input matInput [(ngModel)]="row.new_concept_code" (ngModelChange)="onNewTermEdited()">
        </mat-form-field>
        @if (field.hierarchic) {
          <app-concept-picker
            class="row-detail__create-parent"
            label="TRANS__IMPORT__VALUE_REVIEW__CREATE_UNDER"
            [required]="false"
            [options]="parentOptions"
            [control]="parentControl"
          ></app-concept-picker>
        }
      </div>
    }

    @case ('split') {
      <p class="row-detail__lead">
        {{ 'TRANS__IMPORT__VALUE_REVIEW__SPLIT_LEAD' | translate: {delimiter: field.split_delimiter} }}
      </p>
      <ul class="row-detail__pieces">
        @for (p of pieceViews; track p.piece.value_key) {
          <li class="row-detail__piece">
            <span class="row-detail__piece-value">{{ p.piece.value }}</span>
            <mat-icon class="row-detail__arrow" aria-hidden="true">arrow_forward</mat-icon>
            @if (p.row && p.view) {
              <app-run-outcome [view]="p.view"></app-run-outcome>
              <button mat-button type="button" color="primary" (click)="jumpToRow.emit(p.row)">
                {{ 'TRANS__IMPORT__VALUE_REVIEW__GO_TO_VALUE' | translate: {value: p.piece.value} }}
              </button>
            } @else {
              <span class="row-detail__piece-known">
                {{ 'TRANS__IMPORT__VALUE_REVIEW__PIECE_NAMES_TERM' | translate }}
              </span>
            }
          </li>
        }
      </ul>
    }
  }
</div>
